import type {
  CreateMemberRequest,
  IssueEnrollmentRequest,
  IssueEnrollmentResponse,
  ListMembersResponse,
  MemberResponse,
  MemberVehicleResponse,
  ReassignMemberVehicleRequest,
} from '@jq4race/shared';

import { request } from './client.js';

// frequent-customer-memberships · Slice S2a — Member & Vehicle Identity
// (Capability 2). Org-level, sibling of /admin/membership-plans — routes
// hang off /admin/members directly (not location-scoped).

export async function listMembers(): Promise<ListMembersResponse> {
  return request<ListMembersResponse>('/admin/members', { method: 'GET' });
}

export async function createMember(input: CreateMemberRequest): Promise<MemberResponse> {
  return request<MemberResponse>('/admin/members', { method: 'POST', body: input });
}

export async function reassignMemberVehicle(
  input: ReassignMemberVehicleRequest,
): Promise<MemberVehicleResponse> {
  return request<MemberVehicleResponse>('/admin/members/vehicles/reassign', {
    method: 'POST',
    body: input,
  });
}

// frequent-customer-memberships · Slice S2b-BE — admin-initiated enrollment
// (Capability 3). Mints the HMAC enrollment challenge + emails the link.
export async function issueEnrollment(
  memberId: string,
  input: IssueEnrollmentRequest,
): Promise<IssueEnrollmentResponse> {
  return request<IssueEnrollmentResponse>(`/admin/members/${memberId}/enroll`, {
    method: 'POST',
    body: input,
  });
}
